import { CharacterSkill } from '~/shared';

export const skillNames: Record<CharacterSkill, string> = {
	[CharacterSkill.JOB_FARMER]: 'Фермерство',
	[CharacterSkill.JOB_TAXI]: 'Такси',
	[CharacterSkill.JOB_COURIER]: 'Курьер',
	[CharacterSkill.JOB_BUS]: 'Автобус',
	[CharacterSkill.JOB_PIZZA_DELIVERY]: 'Пицца',
	[CharacterSkill.JOB_ELECTRICIAN]: 'Электрик',
	[CharacterSkill.JOB_POST]: 'Почтальон',
	[CharacterSkill.HOBBY_FISHING]: 'Рыболовство',
};

export const jobSkills: CharacterSkill[] = [
	CharacterSkill.JOB_FARMER,
	CharacterSkill.JOB_TAXI,
	CharacterSkill.JOB_COURIER,
	CharacterSkill.JOB_BUS,
	CharacterSkill.JOB_PIZZA_DELIVERY,
	CharacterSkill.JOB_ELECTRICIAN,
];

export const hobbySkills: CharacterSkill[] = [CharacterSkill.HOBBY_FISHING];

export interface ISkillData {
	skill: CharacterSkill;
	name: string;
	level: number;
	maxLevel: number;
	exp: number;
	maxExp: number;
}

export const sortSkills = (skills: ISkillData[]): ISkillData[] => {
	return [...skills].sort((a, b) => {
		const aIsCompleted = a.level === a.maxLevel;
		const bIsCompleted = b.level === b.maxLevel;
		const aIsInactive = a.level === 1 && a.exp === 0;
		const bIsInactive = b.level === 1 && b.exp === 0;

		// Сначала выполненные
		if (aIsCompleted && !bIsCompleted) return -1;
		if (!aIsCompleted && bIsCompleted) return 1;

		// Неактивные в конец
		if (aIsInactive && !bIsInactive) return 1;
		if (!aIsInactive && bIsInactive) return -1;

		// По уровню (от большего к меньшему)
		if (a.level !== b.level) {
			return b.level - a.level;
		}

		// По % заполненности
		const aProgress = a.maxExp > 0 ? a.exp / a.maxExp : 0;
		const bProgress = b.maxExp > 0 ? b.exp / b.maxExp : 0;
		return bProgress - aProgress;
	});
};

export const sortSkillsForMain = (skills: ISkillData[]): ISkillData[] => {
	const inProgress: ISkillData[] = [];
	const completed: ISkillData[] = [];
	const notStarted: ISkillData[] = [];

	skills.forEach((skill) => {
		const isCompleted = skill.level === skill.maxLevel;
		const isInactive = skill.level === 1 && skill.exp === 0;

		if (isCompleted) {
			completed.push(skill);
		} else if (isInactive) {
			notStarted.push(skill);
		} else {
			inProgress.push(skill);
		}
	});

	inProgress.sort((a, b) => {
		if (a.level !== b.level) {
			return b.level - a.level;
		}
		const aProgress = a.maxExp > 0 ? a.exp / a.maxExp : 0;
		const bProgress = b.maxExp > 0 ? b.exp / b.maxExp : 0;
		return bProgress - aProgress;
	});

	completed.sort((a, b) => b.level - a.level);

	return [...inProgress, ...completed, ...notStarted];
};
